/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '../request';
/**
 * @description test
 */

export function postApiSwaggerGet(data) {
  return request.post('/api/swagger/get', data);
}
/**
 * @description 登陆
 */

export function getHd(data) {
  return request.get('/hd', {
    params: data
  });
}
/**
 * @description 添加客户档案附件
 */

export function postHdCustomerAnnexAdd(data) {
  return request.post('/hd/customer/annex/add', data);
}
/**
 * @description 删除客户档案附件
 */

export function deleteHdCustomerAnnexDels(data) {
  return request.delete('/hd/customer/annex/dels', {
    params: data
  });
}
/**
 * @description 查找客户档案附件
 */

export function getHdCustomerAnnexList(data) {
  return request.get('/hd/customer/annex/list', {
    params: data
  });
}
/**
 * @description 编辑客诉sla
 */

export function getHdCustomerComplaintSla(data) {
  return request.get('/hd/customer/complaint/sla', {
    params: data
  });
}
/**
 * @description 新建客户投诉
 */

export function postHdCustomerComplaintsAdd(data) {
  return request.post('/hd/customer/complaints/add', data);
}
/**
 * @description 客户投诉列表数量
 */

export function getHdCustomerComplaintsCount(data) {
  return request.get('/hd/customer/complaints/count', {
    params: data
  });
}
/**
 * @description 删除客户投诉详情
 */

export function deleteHdCustomerComplaintsDels(data) {
  return request.delete('/hd/customer/complaints/dels', {
    params: data
  });
}
/**
 * @description 客户投诉详情
 */

export function getHdCustomerComplaintsDetails(data) {
  return request.get('/hd/customer/complaints/details', {
    params: data
  });
}
/**
 * @description 完成
 */

export function putHdCustomerComplaintsFinish(data) {
  return request.put('/hd/customer/complaints/finish', data);
}
/**
 * @description 客户投诉列表
 */

export function getHdCustomerComplaintsList(data) {
  return request.get('/hd/customer/complaints/list', {
    params: data
  });
}
/**
 * @description 回访
 */

export function putHdCustomerComplaintsReturnVisit(data) {
  return request.put('/hd/customer/complaints/return/visit', data);
}
/**
 * @description 修改客户投诉
 */

export function putHdCustomerComplaintsUpdate(data) {
  return request.put('/hd/customer/complaints/update', data);
}
/**
 * @description 新建客户增值服务跟进记录
 */

export function postHdCustomerFollowupAdd(data) {
  return request.post('/hd/customer/followup/add', data);
}
/**
 * @description 客户增值服务跟进记录列表数量
 */

export function getHdCustomerFollowupCount(data) {
  return request.get('/hd/customer/followup/count', {
    params: data
  });
}
/**
 * @description 删除客户增值服务跟进记录
 */

export function deleteHdCustomerFollowupDels(data) {
  return request.delete('/hd/customer/followup/dels', {
    params: data
  });
}
/**
 * @description 客户增值服务跟进记录列表
 */

export function getHdCustomerFollowupList(data) {
  return request.get('/hd/customer/followup/list', {
    params: data
  });
}
/**
 * @description 修改客户增值服务跟进记录
 */

export function putHdCustomerFollowupUpdate(data) {
  return request.put('/hd/customer/followup/update', data);
}
/**
 * @description 新建参与方信息
 */

export function postHdCustomerPartakeAdd(data) {
  return request.post('/hd/customer/partake/add', data);
}
/**
 * @description 参与方信息列表数量
 */

export function getHdCustomerPartakeCount(data) {
  return request.get('/hd/customer/partake/count', {
    params: data
  });
}
/**
 * @description 删除参与方信息
 */

export function deleteHdCustomerPartakeDels(data) {
  return request.delete('/hd/customer/partake/dels', {
    params: data
  });
}
/**
 * @description 参与方信息列表
 */

export function getHdCustomerPartakeList(data) {
  return request.get('/hd/customer/partake/list', {
    params: data
  });
}
/**
 * @description 修改参与方信息
 */

export function putHdCustomerPartakeUpdate(data) {
  return request.put('/hd/customer/partake/update', data);
}
/**
 * @description 新建客户设备情况
 */

export function postHdCustomerProductionAdd(data) {
  return request.post('/hd/customer/production/add', data);
}
/**
 * @description 客户设备情况列表数量
 */

export function getHdCustomerProductionCount(data) {
  return request.get('/hd/customer/production/count', {
    params: data
  });
}
/**
 * @description 删除客户设备情况
 */

export function deleteHdCustomerProductionDels(data) {
  return request.delete('/hd/customer/production/dels', {
    params: data
  });
}
/**
 * @description 客户设备情况列表
 */

export function getHdCustomerProductionList(data) {
  return request.get('/hd/customer/production/list', {
    params: data
  });
}
/**
 * @description 修改客户设备情况
 */

export function putHdCustomerProductionUpdate(data) {
  return request.put('/hd/customer/production/update', data);
}
/**
 * @description 新建客户档案
 */

export function postHdCustomerRecordAdd(data) {
  return request.post('/hd/customer/record/add', data);
}
/**
 * @description 客户档案列表数量
 */

export function getHdCustomerRecordCount(data) {
  return request.get('/hd/customer/record/count', {
    params: data
  });
}
/**
 * @description 删除客户档案
 */

export function deleteHdCustomerRecordDels(data) {
  return request.delete('/hd/customer/record/dels', {
    params: data
  });
}
/**
 * @description 客户档案详情
 */

export function getHdCustomerRecordDetails(data) {
  return request.get('/hd/customer/record/details', {
    params: data
  });
}
/**
 * @description 客户档案列表
 */

export function getHdCustomerRecordList(data) {
  return request.get('/hd/customer/record/list', {
    params: data
  });
}
/**
 * @description 修改客户档案
 */

export function putHdCustomerRecordUpdate(data) {
  return request.put('/hd/customer/record/update', data);
}
/**
 * @description 新建项目客户来源
 */

export function postHdCustomerSourceAdd(data) {
  return request.post('/hd/customer/source/add', data);
}
/**
 * @description 项目客户来源列表数量
 */

export function getHdCustomerSourceCount(data) {
  return request.get('/hd/customer/source/count', {
    params: data
  });
}
/**
 * @description 删除项目客户来源
 */

export function deleteHdCustomerSourceDels(data) {
  return request.delete('/hd/customer/source/dels', {
    params: data
  });
}
/**
 * @description 项目客户来源列表
 */

export function getHdCustomerSourceList(data) {
  return request.get('/hd/customer/source/list', {
    params: data
  });
}
/**
 * @description 修改项目客户来源
 */

export function putHdCustomerSourceUpdate(data) {
  return request.put('/hd/customer/source/update', data);
}
/**
 * @description 新建字典值
 */

export function postHdDictionaryAdd(data) {
  return request.post('/hd/dictionary/add', data);
}
/**
 * @description 字典值列表数量
 */

export function getHdDictionaryCount(data) {
  return request.get('/hd/dictionary/count', {
    params: data
  });
}
/**
 * @description 删除字典值详情
 */

export function deleteHdDictionaryDels(data) {
  return request.delete('/hd/dictionary/dels', {
    params: data
  });
}
/**
 * @description 字典值详情
 */

export function getHdDictionaryDetails(data) {
  return request.get('/hd/dictionary/details', {
    params: data
  });
}
/**
 * @description 字典值列表
 */

export function getHdDictionaryList(data) {
  return request.get('/hd/dictionary/list', {
    params: data
  });
}
/**
 * @description 修改字典值
 */

export function putHdDictionaryUpdate(data) {
  return request.put('/hd/dictionary/update', data);
}
/**
 * @description 新建委托服务费用
 */

export function postHdEntrustServiceFeeAdd(data) {
  return request.post('/hd/entrust/service/fee/add', data);
}
/**
 * @description 委托服务费用列表数量
 */

export function getHdEntrustServiceFeeCount(data) {
  return request.get('/hd/entrust/service/fee/count', {
    params: data
  });
}
/**
 * @description 删除委托服务费用详情
 */

export function deleteHdEntrustServiceFeeDels(data) {
  return request.delete('/hd/entrust/service/fee/dels', {
    params: data
  });
}
/**
 * @description 委托服务费用详情
 */

export function getHdEntrustServiceFeeDetails(data) {
  return request.get('/hd/entrust/service/fee/details', {
    params: data
  });
}
/**
 * @description 委托服务费用列表
 */

export function getHdEntrustServiceFeeList(data) {
  return request.get('/hd/entrust/service/fee/list', {
    params: data
  });
}
/**
 * @description 修改委托服务费用
 */

export function putHdEntrustServiceFeeUpdate(data) {
  return request.put('/hd/entrust/service/fee/update', data);
}
/**
 * @description 新建跟进内容
 */

export function postHdFollowContentAdd(data) {
  return request.post('/hd/follow/content/add', data);
}
/**
 * @description 跟进内容列表数量
 */

export function getHdFollowContentCount(data) {
  return request.get('/hd/follow/content/count', {
    params: data
  });
}
/**
 * @description 删除跟进内容详情
 */

export function deleteHdFollowContentDels(data) {
  return request.delete('/hd/follow/content/dels', {
    params: data
  });
}
/**
 * @description 跟进内容详情
 */

export function getHdFollowContentDetails(data) {
  return request.get('/hd/follow/content/details', {
    params: data
  });
}
/**
 * @description 跟进内容列表
 */

export function getHdFollowContentList(data) {
  return request.get('/hd/follow/content/list', {
    params: data
  });
}
/**
 * @description 修改跟进内容
 */

export function putHdFollowContentUpdate(data) {
  return request.put('/hd/follow/content/update', data);
}
/**
 * @description 登陆
 */

export function getHdIndex(data) {
  return request.get('/hd/index', {
    params: data
  });
}
/**
 * @description 库存列表数量
 */

export function getHdInventoryManageCount(data) {
  return request.get('/hd/inventory/manage/count', {
    params: data
  });
}
/**
 * @description 库存列表
 */

export function getHdInventoryManageList(data) {
  return request.get('/hd/inventory/manage/list', {
    params: data
  });
}
/**
 * @description 出入库日志列表数量
 */

export function getHdInventoryManageLogCount(data) {
  return request.get('/hd/inventory/manage/logCount', {
    params: data
  });
}
/**
 * @description 出入库日志列表
 */

export function getHdInventoryManageLogList(data) {
  return request.get('/hd/inventory/manage/logList', {
    params: data
  });
}
/**
 * @description 物料列表数量
 */

export function getHdInventoryManageMaterialCount(data) {
  return request.get('/hd/inventory/manage/materialCount', {
    params: data
  });
}
/**
 * @description 物料列表
 */

export function getHdInventoryManageMaterialList(data) {
  return request.get('/hd/inventory/manage/materialList', {
    params: data
  });
}
/**
 * @description 物料日志列表数量
 */

export function getHdInventoryManageMaterialLogCount(data) {
  return request.get('/hd/inventory/manage/materialLogCount', {
    params: data
  });
}
/**
 * @description 物料日志列表
 */

export function getHdInventoryManageMaterialLogList(data) {
  return request.get('/hd/inventory/manage/materialLogList', {
    params: data
  });
}
/**
 * @description 批量入库/出库
 */

export function postHdInventoryManageUpdateStock(data) {
  return request.post('/hd/inventory/manage/updateStock', data);
}
/**
 * @description 知识库审批列表数量
 */

export function getHdKnowledgeDocApproveCount(data) {
  return request.get('/hd/knowledge/doc/approve/count', {
    params: data
  });
}
/**
 * @description 知识库审批列表
 */

export function getHdKnowledgeDocApproveList(data) {
  return request.get('/hd/knowledge/doc/approve/list', {
    params: data
  });
}
/**
 * @description 新建跟进内容
 */

export function postHdKnowledgeDocSaveOrEditorKnowledge(data) {
  return request.post('/hd/knowledge/doc/saveOrEditorKnowledge', data);
}
/**
 * @description 新建物资返厂单
 */

export function postHdMaterialReturnFormAdd(data) {
  return request.post('/hd/material/return/form/add', data);
}
/**
 * @description 关闭物资返厂单
 */

export function putHdMaterialReturnFormClose(data) {
  return request.put('/hd/material/return/form/close', data);
}
/**
 * @description 物资返厂单列表数量
 */

export function getHdMaterialReturnFormCount(data) {
  return request.get('/hd/material/return/form/count', {
    params: data
  });
}
/**
 * @description 删除物资返厂单
 */

export function deleteHdMaterialReturnFormDels(data) {
  return request.delete('/hd/material/return/form/dels', {
    params: data
  });
}
/**
 * @description 物资返厂单详情
 */

export function getHdMaterialReturnFormDetails(data) {
  return request.get('/hd/material/return/form/details', {
    params: data
  });
}
/**
 * @description 物资返厂单列表
 */

export function getHdMaterialReturnFormList(data) {
  return request.get('/hd/material/return/form/list', {
    params: data
  });
}
/**
 * @description 修改物资返厂单
 */

export function putHdMaterialReturnFormUpdate(data) {
  return request.put('/hd/material/return/form/update', data);
}
/**
 * @description 新建物料值
 */

export function postHdMaterialsAdd(data) {
  return request.post('/hd/materials/add', data);
}
/**
 * @description 物料值列表数量
 */

export function getHdMaterialsCount(data) {
  return request.get('/hd/materials/count', {
    params: data
  });
}
/**
 * @description 删除物料值详情
 */

export function deleteHdMaterialsDels(data) {
  return request.delete('/hd/materials/dels', {
    params: data
  });
}
/**
 * @description 物料值详情
 */

export function getHdMaterialsDetails(data) {
  return request.get('/hd/materials/details', {
    params: data
  });
}
/**
 * @description 物料值列表
 */

export function getHdMaterialsList(data) {
  return request.get('/hd/materials/list', {
    params: data
  });
}
/**
 * @description 修改物料值
 */

export function putHdMaterialsUpdate(data) {
  return request.put('/hd/materials/update', data);
}
/**
 * @description getAllMenu
 */

export function getHdMenuList(data) {
  return request.get('/hd/menu/list', {
    params: data
  });
}
/**
 * @description 新建派工单
 */

export function postHdOrderAdd(data) {
  return request.post('/hd/order/add', data);
}
/**
 * @description 派工单列表数量
 */

export function getHdOrderCount(data) {
  return request.get('/hd/order/count', {
    params: data
  });
}
/**
 * @description 删除派工单
 */

export function deleteHdOrderDels(data) {
  return request.delete('/hd/order/dels', {
    params: data
  });
}
/**
 * @description 派工单详情
 */

export function getHdOrderDetails(data) {
  return request.get('/hd/order/details', {
    params: data
  });
}
/**
 * @description 派工单列表
 */

export function getHdOrderList(data) {
  return request.get('/hd/order/list', {
    params: data
  });
}
/**
 * @description 添加进度
 */

export function putHdOrderProductionProgress(data) {
  return request.put('/hd/order/production/progress', data);
}
/**
 * @description 新建维保及应及委托申请单
 */

export function postHdOrderProxyFormAdd(data) {
  return request.post('/hd/order/proxy/form/add', data);
}
/**
 * @description 审批
 */

export function putHdOrderProxyFormApprove(data) {
  return request.put('/hd/order/proxy/form/approve', data);
}
/**
 * @description 维保及应及委托申请单列表数量
 */

export function getHdOrderProxyFormCount(data) {
  return request.get('/hd/order/proxy/form/count', {
    params: data
  });
}
/**
 * @description 申报
 */

export function putHdOrderProxyFormDeclare(data) {
  return request.put('/hd/order/proxy/form/declare', data);
}
/**
 * @description 维保及应及委托申请单详情
 */

export function getHdOrderProxyFormDetails(data) {
  return request.get('/hd/order/proxy/form/details', {
    params: data
  });
}
/**
 * @description 维保及应及委托申请单列表
 */

export function getHdOrderProxyFormList(data) {
  return request.get('/hd/order/proxy/form/list', {
    params: data
  });
}
/**
 * @description 修改维保及应及委托申请单
 */

export function putHdOrderProxyFormUpdate(data) {
  return request.put('/hd/order/proxy/form/update', data);
}
/**
 * @description 保存服务单
 */

export function putHdOrderSaveServerOrder(data) {
  return request.put('/hd/order/save/server/order', data);
}
/**
 * @description 派工单服务内容
 */

export function getHdOrderServiceContent(data) {
  return request.get('/hd/order/h5/save/service/content', {
    params: data
  });
}
/**
 * @description 派工单服务内容数量
 */

export function getHdOrderServiceContentCount(data) {
  return request.get('/hd/order/service/content/count', {
    params: data
  });
}
/**
 * @description 派工单服务进度
 */

export function getHdOrderServiceProgress(data) {
  return request.get('/hd/order/h5/save/service/progress', {
    params: data
  });
}
/**
 * @description 编辑工单sla
 */

export function getHdOrderSla(data) {
  return request.get('/hd/order/sla', {
    params: data
  });
}
/**
 * @description 修改派工单
 */

export function putHdOrderUpdate(data) {
  return request.put('/hd/order/update', data);
}
/**
 * @description 编辑派工单设备
 */

export function putHdOrderUpdateProduction(data) {
  return request.put('/hd/order/update/production', data);
}
/**
 * @description 新建产品类别
 */

export function postHdProductionCategoryAdd(data) {
  return request.post('/hd/production/category/add', data);
}
/**
 * @description 产品类别列表数量
 */

export function getHdProductionCategoryCount(data) {
  return request.get('/hd/production/category/count', {
    params: data
  });
}
/**
 * @description 删除产品类别详情
 */

export function deleteHdProductionCategoryDels(data) {
  return request.delete('/hd/production/category/dels', {
    params: data
  });
}
/**
 * @description 产品类别详情
 */

export function getHdProductionCategoryDetails(data) {
  return request.get('/hd/production/category/details', {
    params: data
  });
}
/**
 * @description 产品类别列表
 */

export function getHdProductionCategoryList(data) {
  return request.get('/hd/production/category/list', {
    params: data
  });
}
/**
 * @description 新建产品类别节点
 */

export function postHdProductionCategoryNodeAdd(data) {
  return request.post('/hd/production/category/node/add', data);
}
/**
 * @description 产品类别节点列表数量
 */

export function getHdProductionCategoryNodeCount(data) {
  return request.get('/hd/production/category/node/count', {
    params: data
  });
}
/**
 * @description 删除产品类别节点详情
 */

export function deleteHdProductionCategoryNodeDels(data) {
  return request.delete('/hd/production/category/node/dels', {
    params: data
  });
}
/**
 * @description 产品类别节点详情
 */

export function getHdProductionCategoryNodeDetails(data) {
  return request.get('/hd/production/category/node/details', {
    params: data
  });
}
/**
 * @description 产品类别节点列表
 */

export function getHdProductionCategoryNodeList(data) {
  return request.get('/hd/production/category/node/list', {
    params: data
  });
}
/**
 * @description 修改产品类别节点
 */

export function putHdProductionCategoryNodeUpdate(data) {
  return request.put('/hd/production/category/node/update', data);
}
/**
 * @description 修改产品类别
 */

export function putHdProductionCategoryUpdate(data) {
  return request.put('/hd/production/category/update', data);
}
/**
 * @description 新建项目
 */

export function postHdProjectAdd(data) {
  return request.post('/hd/project/add', data);
}
/**
 * @description 整站委托
 */

export function putHdProjectCommission(data) {
  return request.put('/hd/project/commission', data);
}
/**
 * @description 项目列表数量
 */

export function getHdProjectCount(data) {
  return request.get('/hd/project/count', {
    params: data
  });
}
/**
 * @description 删除项目详情
 */

export function deleteHdProjectDels(data) {
  return request.delete('/hd/project/dels', {
    params: data
  });
}
/**
 * @description 项目详情
 */

export function getHdProjectDetails(data) {
  return request.get('/hd/project/details', {
    params: data
  });
}
/**
 * @description 新建缺件出厂单
 */

export function postHdProjectLackDeliverAdd(data) {
  return request.post('/hd/project/lack/deliver/add', data);
}
/**
 * @description 缺件出厂单列表数量
 */

export function getHdProjectLackDeliverCount(data) {
  return request.get('/hd/project/lack/deliver/count', {
    params: data
  });
}
/**
 * @description 缺件出厂单详情
 */

export function getHdProjectLackDeliverDetails(data) {
  return request.get('/hd/project/lack/deliver/details', {
    params: data
  });
}
/**
 * @description 缺件出厂单列表
 */

export function getHdProjectLackDeliverList(data) {
  return request.get('/hd/project/lack/deliver/list', {
    params: data
  });
}
/**
 * @description 修改缺件出厂单
 */

export function putHdProjectLackDeliverUpdate(data) {
  return request.put('/hd/project/lack/deliver/update', data);
}
/**
 * @description 项目列表
 */

export function getHdProjectList(data) {
  return request.get('/hd/project/list', {
    params: data
  });
}
/**
 * @description 项目计划列表数量
 */

export function getHdProjectPlanCount(data) {
  return request.get('/hd/project/plan/count', {
    params: data
  });
}
/**
 * @description 项目计划列表
 */

export function getHdProjectPlanList(data) {
  return request.get('/hd/project/plan/list', {
    params: data
  });
}
/**
 * @description 修改项目计划
 */

export function putHdProjectPlanUpdate(data) {
  return request.put('/hd/project/plan/update', data);
}
/**
 * @description 项目产品列表数量
 */

export function getHdProjectProductCount(data) {
  return request.get('/hd/project/product/count', {
    params: data
  });
}
/**
 * @description 编辑出厂编号
 */

export function putHdProjectProductEditNo(data) {
  return request.put('/hd/project/product/edit/no', data);
}
/**
 * @description 项目产品编辑进度
 */

export function putHdProjectProductEditProgress(data) {
  return request.put('/hd/project/product/edit/progress', data);
}
/**
 * @description 项目产品列表
 */

export function getHdProjectProductList(data) {
  return request.get('/hd/project/product/list', {
    params: data
  });
}
/**
 * @description 项目产品进度列表
 */

export function getHdProjectProductProgress(data) {
  return request.get('/hd/project/product/progress', {
    params: data
  });
}
/**
 * @description 项目产品退回进度
 */

export function putHdProjectProductReturnProgress(data) {
  return request.put('/hd/project/product/return/progress', data);
}
/**
 * @description 项目进度
 */

export function getHdProjectProgress(data) {
  return request.get('/hd/project/progress', {
    params: data
  });
}
/**
 * @description 新建整站委托申请单
 */

export function postHdProjectProxyFormAdd(data) {
  return request.post('/hd/project/proxy/form/add', data);
}
/**
 * @description 审批
 */

export function putHdProjectProxyFormApprove(data) {
  return request.put('/hd/project/proxy/form/approve', data);
}
/**
 * @description 整站委托申请单列表数量
 */

export function getHdProjectProxyFormCount(data) {
  return request.get('/hd/project/proxy/form/count', {
    params: data
  });
}
/**
 * @description 申报
 */

export function putHdProjectProxyFormDeclare(data) {
  return request.put('/hd/project/proxy/form/declare', data);
}
/**
 * @description 整站委托申请单详情
 */

export function getHdProjectProxyFormDetails(data) {
  return request.get('/hd/project/proxy/form/details', {
    params: data
  });
}
/**
 * @description 整站委托申请单列表
 */

export function getHdProjectProxyFormList(data) {
  return request.get('/hd/project/proxy/form/list', {
    params: data
  });
}
/**
 * @description 修改整站委托申请单
 */

export function putHdProjectProxyFormUpdate(data) {
  return request.put('/hd/project/proxy/form/update', data);
}
/**
 * @description 新建项目行项
 */

export function postHdProjectRowAdd(data) {
  return request.post('/hd/project/row/add', data);
}
/**
 * @description 项目行项列表数量
 */

export function getHdProjectRowCount(data) {
  return request.get('/hd/project/row/count', {
    params: data
  });
}
/**
 * @description 删除项目行项
 */

export function deleteHdProjectRowDels(data) {
  return request.delete('/hd/project/row/dels', {
    params: data
  });
}
/**
 * @description 项目行项详情
 */

export function getHdProjectRowDetails(data) {
  return request.get('/hd/project/row/details', {
    params: data
  });
}
/**
 * @description 项目列表
 */

export function getHdProjectRowList(data) {
  return request.get('/hd/project/row/list', {
    params: data
  });
}
/**
 * @description 修改项目行项
 */

export function putHdProjectRowUpdate(data) {
  return request.put('/hd/project/row/update', data);
}
/**
 * @description 修改项目
 */

export function putHdProjectUpdate(data) {
  return request.put('/hd/project/update', data);
}
/**
 * @description 新建报销单详情
 */

export function postHdReimbursementDetailAdd(data) {
  return request.post('/hd/reimbursement/detail/add', data);
}
/**
 * @description 报销单详情列表数量
 */

export function getHdReimbursementDetailCount(data) {
  return request.get('/hd/reimbursement/detail/count', {
    params: data
  });
}
/**
 * @description 删除报销单详情
 */

export function deleteHdReimbursementDetailDels(data) {
  return request.delete('/hd/reimbursement/detail/dels', {
    params: data
  });
}
/**
 * @description 报销单详情列表
 */

export function getHdReimbursementDetailList(data) {
  return request.get('/hd/reimbursement/detail/list', {
    params: data
  });
}
/**
 * @description 修改报销单详情
 */

export function putHdReimbursementDetailUpdate(data) {
  return request.put('/hd/reimbursement/detail/update', data);
}
/**
 * @description 新建报销单
 */

export function postHdReimbursementFormAdd(data) {
  return request.post('/hd/reimbursement/form/add', data);
}
/**
 * @description 报销单列表数量
 */

export function getHdReimbursementFormCount(data) {
  return request.get('/hd/reimbursement/form/count', {
    params: data
  });
}
/**
 * @description 删除报销单
 */

export function deleteHdReimbursementFormDels(data) {
  return request.delete('/hd/reimbursement/form/dels', {
    params: data
  });
}
/**
 * @description 报销单详情
 */

export function getHdReimbursementFormDetails(data) {
  return request.get('/hd/reimbursement/form/details', {
    params: data
  });
}
/**
 * @description 报销单列表
 */

export function getHdReimbursementFormList(data) {
  return request.get('/hd/reimbursement/form/list', {
    params: data
  });
}
/**
 * @description 修改报销单
 */

export function putHdReimbursementFormUpdate(data) {
  return request.put('/hd/reimbursement/form/update', data);
}
/**
 * @description 报销单推送
 */

export function putHdReimbursementFormPush(data) {
  return request.get('/hd/reimbursement/form/getPushCardNumber', {
    params: data
  });
}
/**
 * @description 新建现场问题
 */

export function postHdSceneProblemAdd(data) {
  return request.post('/hd/scene/problem/add', data);
}
/**
 * @description 现场问题列表数量
 */

export function getHdSceneProblemCount(data) {
  return request.get('/hd/scene/problem/count', {
    params: data
  });
}
/**
 * @description 处理现场问题
 */

export function putHdSceneProblemDealWith(data) {
  return request.put('/hd/scene/problem/dealWith', data);
}
/**
 * @description 删除现场问题
 */

export function deleteHdSceneProblemDels(data) {
  return request.delete('/hd/scene/problem/dels', {
    params: data
  });
}
/**
 * @description 现场问题详情
 */

export function getHdSceneProblemDetails(data) {
  return request.get('/hd/scene/problem/details', {
    params: data
  });
}
/**
 * @description 新建现场问题单
 */

export function postHdSceneProblemFormAdd(data) {
  return request.post('/hd/scene/problem/form/add', data);
}
/**
 * @description 审批现场问题单
 */

export function putHdSceneProblemFormApprove(data) {
  return request.put('/hd/scene/problem/form/approve', data);
}
/**
 * @description 现场问题单关联工单列表数量
 */

export function getHdSceneProblemFormAssociateOrderCount(data) {
  return request.get('/hd/scene/problem/form/associate/order/count', {
    params: data
  });
}
/**
 * @description 现场问题单关联工单列表
 */

export function getHdSceneProblemFormAssociateOrderList(data) {
  return request.get('/hd/scene/problem/form/associate/order/list', {
    params: data
  });
}
/**
 * @description 现场问题单列表数量
 */

export function getHdSceneProblemFormCount(data) {
  return request.get('/hd/scene/problem/form/count', {
    params: data
  });
}
/**
 * @description 删除现场问题单
 */

export function deleteHdSceneProblemFormDels(data) {
  return request.delete('/hd/scene/problem/form/dels', {
    params: data
  });
}
/**
 * @description 现场问题单详情
 */

export function getHdSceneProblemFormDetails(data) {
  return request.get('/hd/scene/problem/form/details', {
    params: data
  });
}
/**
 * @description 现场问题单列表
 */

export function getHdSceneProblemFormList(data) {
  return request.get('/hd/scene/problem/form/list', {
    params: data
  });
}
/**
 * @params {integer} feedback_time.nanos -
 * @params {integer} approval_time.nanos -
 * @params {integer} pageIndex -
 * @params {integer} pageSize -
 * @params {integer} id - id
 * @params {integer} fk_t_enterprise_id - 企业id
 * @params {integer} obj_type - 现场问题对象类型
 * @params {integer} fk_t_hd_project_id - 项目id
 * @params {integer} fk_t_hd_order_id - 华电项目派工单
 * @params {string} title - 标题
 * @params {string} flow_order_no - 流转单单号
 * @params {integer} fk_t_feedback_user_id - 反馈人员
 * @params {integer} service_type - 服务类型
 * @params {integer} submit_state - 提交状态
 * @params {integer} is_required_approval - 是否需要审批
 * @params {integer} approval_state - 审批状态
 * @params {integer} fk_t_approval_user_id - 审批人
 * @params {string} approval_note - 审批备注
 * @params {integer} state - 状态
 * @params {string} ctoken - ctoken
 * @params {integer} scene_problem_state - 现场问题状态
 * @params {string} contract_no - 项目号
 * @params {string} keyword - 关键字
 * @params {string} describe - 问题描述
 * @params {integer} cause_type - 原因分类
 * @params {integer} process_state - 问题处理状态
 * @params {integer} is_need_return - 物资是否需要返厂
 * @params {string} leave_factory_no - 出厂编号
 * @description 工单关联现场问题单列表
 */

export function getHdOrderAssociateSceneProblemFormList(data) {
  return request.get('/hd/order/associate/scene/problem/form/list', {
    params: data
  });
}
/**
 * @description 提交现场问题单
 */

export function putHdSceneProblemFormSubmit(data) {
  return request.put('/hd/scene/problem/form/submit', data);
}
/**
 * @description 修改现场问题单
 */

export function putHdSceneProblemFormUpdate(data) {
  return request.put('/hd/scene/problem/form/update', data);
}
/**
 * @description 现场问题列表
 */

export function getHdSceneProblemList(data) {
  return request.get('/hd/scene/problem/list', {
    params: data
  });
}
/**
 * @description 修改现场问题
 */

export function putHdSceneProblemUpdate(data) {
  return request.put('/hd/scene/problem/update', data);
}
/**
 * @description 未来发货项目
 */

export function getHdServiceLoadFutureShipment(data) {
  return request.get('/hd/service/load/future/shipment', {
    params: data
  });
}
/**
 * @description 已发货项目
 */

export function getHdServiceLoadShipped(data) {
  return request.get('/hd/service/load/shipped', {
    params: data
  });
}
/**
 * @description 签到列表数量
 */

export function getHdSignCount(data) {
  return request.get('/hd/sign/count', {
    params: data
  });
}
/**
 * @description 签到
 */

export function postHdSignIn(data) {
  return request.post('/hd/sign/in', data);
}
/**
 * @description 签到列表
 */

export function getHdSignList(data) {
  return request.get('/hd/sign/list', {
    params: data
  });
}
/**
 * @description 签退
 */

export function postHdSignOut(data) {
  return request.post('/hd/sign/out', data);
}
/**
 * @description 新建配件申请单
 */

export function postHdSparepartApplyFormAdd(data) {
  return request.post('/hd/sparepart/apply/form/add', data);
}
/**
 * @description 配件申请单列表数量
 */

export function getHdSparepartApplyFormCount(data) {
  return request.get('/hd/sparepart/apply/form/count', {
    params: data
  });
}
/**
 * @description 处理配件申请单
 */

export function putHdSparepartApplyFormDealWith(data) {
  return request.put('/hd/sparepart/apply/form/dealWith', data);
}
/**
 * @description 删除配件申请单
 */

export function deleteHdSparepartApplyFormDels(data) {
  return request.delete('/hd/sparepart/apply/form/dels', {
    params: data
  });
}
/**
 * @description 新建配件申请单明细
 */

export function postHdSparepartApplyFormDetailAdd(data) {
  return request.post('/hd/sparepart/apply/form/detail/add', data);
}
/**
 * @description 配件申请单明细列表数量
 */

export function getHdSparepartApplyFormDetailCount(data) {
  return request.get('/hd/sparepart/apply/form/detail/count', {
    params: data
  });
}
/**
 * @description 处理配件申请
 */

export function putHdSparepartApplyFormDetailDealWith(data) {
  return request.put('/hd/sparepart/apply/form/detail/dealWith', data);
}
/**
 * @description 删除配件申请单明细
 */

export function deleteHdSparepartApplyFormDetailDels(data) {
  return request.delete('/hd/sparepart/apply/form/detail/dels', {
    params: data
  });
}
/**
 * @description 配件申请单明细列表
 */

export function getHdSparepartApplyFormDetailList(data) {
  return request.get('/hd/sparepart/apply/form/detail/list', {
    params: data
  });
}
/**
 * @description 修改配件申请单明细
 */

export function putHdSparepartApplyFormDetailUpdate(data) {
  return request.put('/hd/sparepart/apply/form/detail/update', data);
}
/**
 * @description 配件申请单详情
 */

export function getHdSparepartApplyFormDetails(data) {
  return request.get('/hd/sparepart/apply/form/details', {
    params: data
  });
}
/**
 * @description 配件申请单列表
 */

export function getHdSparepartApplyFormList(data) {
  return request.get('/hd/sparepart/apply/form/list', {
    params: data
  });
}
/**
 * @description 修改配件申请单
 */

export function putHdSparepartApplyFormUpdate(data) {
  return request.put('/hd/sparepart/apply/form/update', data);
}
/**
 * @description 新建工作日志
 */

export function postHdWorkLogAdd(data) {
  return request.post('/hd/work/log/add', data);
}
/**
 * @description 工作日志列表数量
 */

export function getHdWorkLogCount(data) {
  return request.get('/hd/work/log/count', {
    params: data
  });
}
/**
 * @description 删除工作日志
 */

export function deleteHdWorkLogDels(data) {
  return request.delete('/hd/work/log/dels', {
    params: data
  });
}
/**
 * @description 工作日志列表
 */

export function getHdWorkLogList(data) {
  return request.get('/hd/work/log/list', {
    params: data
  });
}
/**
 * @description 修改工作日志
 */

export function putHdWorkLogUpdate(data) {
  return request.put('/hd/work/log/update', data);
}
/**
 * @description 工时申请单审批
 */

export function putHdWorkingHourFormApprove(data) {
  return request.put('/hd/working/hour/form/approve', data);
}
/**
 * @description 受理
 */

export function acceptance(data) {
  return request.post('/hd/order/acceptance', data);
}
/**
 * @description 返单
 */

export function cancel(data) {
  return request.post('/order/cancel', data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
/**
 * @description 指派
 */

export function batchDesignate(data) {
  return request.post('/worker/batchDesignate', data);
}
/**
 * @description 转派团队
 */

export function updateOrderGroupId(data) {
  return request.post('/order/updateOrderGroupId', data);
}
/**
 * @description 预约
 */

export function workerBespokeDate(data) {
  return request.post('/order/workerBespokeDate', data);
}
/**
 * @description 开始服务
 */

export function startService(data) {
  return request.post('/order/startService', data);
}
/**
 * @description 工作日志详情
 */

export function workLogDetails(data) {
  return request.get('/hd/work/log/details', {
    params: data
  });
}
/**
 * @description 服务完成
 */

export function serviceComplete(data) {
  return request.post('/hd/order/serviceComplete', data);
}
/**
 * @description 个人服务绩效
 */

export function getbyUser(data) {
  return request.get('/hd/serviceachievements/getbyUser', {
    params: data
  });
}
/**
 * @description 服务绩效排行
 */

export function rankingList(data) {
  return request.get('/hd/serviceachievements/rankingList', {
    params: data
  });
}
/**
 * @description 项目产品列表数量
 */

export function stockCount(data) {
  return request.get('/hd/stock/count', {
    params: data
  });
}
/**
 * @description 仓库库存列表
 */

export function stockList(data) {
  return request.get('/hd/stock/list', {
    params: data
  });
}
/**
 * @description 仓库出入库日志
 */

export function inoutstocklogCount(data) {
  return request.get('/hd/Inoutstocklog/count', {
    params: data
  });
}
/**
 * @description 仓库出库
 */

export function inoutstocklogOut(data) {
  return request.get('/hd/sparepart/stock/inout/from/list', {
    params: data
  });
}
/**
 * @description 仓库出库列表
 */

export function outList(data) {
  return request.get('/warehouse/list', {
    params: data
  });
}
/**
 * @description 获取物料号
 */

export function getwuliao(data) {
  return request.get('hd/stock/list', {
    params: data
  });
}
/**
 * @description 添加仓库出库
 */

export function addOut(data) {
  return request.post('/hd/sparepart/stock/inout/from/add', data);
}
/**
 * @description 提交投诉
 */

export function addcomplaint(data) {
  return request.post('/customercomplaints/save', data);
}
/**
 * @description 附件
 */

export function encloSure(data) {
  return request.get('/hd/oa/file/list', {
    params: data
  });
}